export default {
  shoppingcartitems: [],
  syncing: false
}
